import { Component, Input, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Router, ActivatedRoute } from '@angular/router';
import { CompartirService } from '../../../../generales/services/compartir.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-producto-botones-top',
  templateUrl: './producto-botones-top.component.html',
  styleUrls: ['./producto-botones-top.component.scss'],
})
export class ProductoBotonesTopComponent implements OnInit {
  @Input() title: string = '';
  @Input() text: string = '';
  @Input() showBtn: boolean = true;
  @Input() routeDir:boolean;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private route: ActivatedRoute,
    private compartirService: CompartirService
  ) {}
  size: string = 'default';
  breakpoint: boolean = false;
  actualPage: string = '';
  path = environment.path;

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 1000px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.size = 'small';
          this.breakpoint = true;
        } else {
          this.size = 'default';
          this.breakpoint = false;
        }
      });

    this.route.params.subscribe(
      (params) => (this.actualPage = params.page || '1')
    );
  }

  back() {
    if(this.routeDir){
      window.history.back()
    }else{
      this.router.navigate([`/market-place/search/${this.actualPage}`]);
    }
  }

  async compartir(ev) {
    const url: string = window.location.href;
    const shareData = {
      title: this.title,
      text: this.text,
      url,
    };

    this.compartirService.compartir(ev, shareData);
  }
}
